$(document).ready(function(){

  $('#show_first_img').click(function() {
      $('.tile-media_img_1').css('display', 'block');
      $('.tile-media_img_2').css('display', 'none');
  });

  $('#show_second_img').click(function() {
      $('.tile-media_img_1').css('display', 'none');
      $('.tile-media_img_2').css('display', 'block');
  });
  
  $('.drawer_cart_icon').on('click',function(){
    $('mobile-navigation').attr('open',false)
  })

  $('.drawer_search_icon').on('click',function(){
    $('predictive-search-drawer .new_menu_back').addClass('active')
    $('mobile-navigation').attr('open',false)
    $('predictive-search-drawer').attr('open',true)
  })

  $('predictive-search-drawer .new_menu_back').on('click',function(){
    
    $('mobile-navigation').attr('open',true)
    $('predictive-search-drawer').attr('open',false)
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })

  $('.search_drawer_search_icon,.search_drawer_cart_icon').on('click',function(){
    $('predictive-search-drawer').attr('open',false)
  })

  $('.drawer__close-button,store-header .header__icon-wrapper[href="/search"]').on('click',function(){
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })


  // $('button[aria-controls="mobile-menu-drawer"]').on('click',function(){
  //   if( $('#mobile-menu-drawer').attr('open') == undefined ){
  //     $('mobile-navigation').attr('open',true)
  //   }
  // })



  // collection page js
 $('body').on('change','#image_toggle',function(){
        let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
        let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
        console.log("click test");
        if (this.checked) {
            // Show second image
            // $('#show_first_img').removeClass('active');
            // $('#show_second_img').addClass('active');
            $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
            $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
        } else {
            // Show first image
            // $('#show_second_img').removeClass('active');
            // $('#show_first_img').addClass('active');
            $primaryImage.attr('style', 'visibility:visible; opacity:1;');
            $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
        }
    });

  
 // collection img click change second image
  $('body').on('click','#show_first_img_col',function(){
    $(this).addClass('active') ;
    $("#show_second_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
    $primaryImage.attr('style', 'visibility:visible; opacity:1;');
    $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
  })

  $('body').on('click','#show_second_img_col',function(){
    $(this).addClass('active') ;
    $("#show_first_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
    
    if ($secondaryImage.length > 0) { 
        $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
        $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
    }
    
  })


  
  
  $('body').on('click','.js-load-more', function(){
   let $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datacollurl = $('[data-coll-url]').val();
    
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');

    
   let nextUrl = $('[data-next-link]').val();
   let current_page_new = currentPage + 1;
   let next_coll = currentPage + 2;
    
   $.ajax({
     url: nextUrl,
     type: 'GET',
     dataType: 'html',
     success: function(responseHTML){
       if(datacollurl.includes('?')){
         $('[data-next-link]').val(datacollurl + "&page="+next_coll);
       }else{
         $('[data-next-link]').val(datacollurl + "?page="+next_coll);
       }
       $('[data-this-page]').val(current_page_new);
       $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
     },
     complete: function() {
       if(current_page_new < totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
       
       if(current_page_new >= totalPages) {
           var queryString = nextUrl.split('?')[1];
            var params = new URLSearchParams(queryString);
            params.delete('page');
            var newQueryString = '&' + params.toString();
            var apiTemplate = 'sold-out-filter-api';
             if ($('body').hasClass('collection-2025')) {
                apiTemplate = 'sold-out-filter-api-2025';
             }
             console.log(apiTemplate);
            $.ajax({
               url: `${datacollurl}?view=${apiTemplate}${newQueryString}`,
               type: 'GET',
               dataType: 'html',
               success: function(responseHTML){
                 $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
               }
             })
         $this.find('[load-more-text]').text('All Products loaded').removeClass('hide'); $this.find('[loader]').addClass('hide');
       } 
     }
   })
  }); 

if (window.location.href.includes("/collections/")) {
  if (!$('.js-load-more').length > 0) {
    let datacollurlNew = $('[data-coll-url]').val();
    let currentURL = window.location.href;
     var apiTemplate = 'sold-out-filter-api';
     if ($('body').hasClass('collection-2025')) {
        apiTemplate = 'sold-out-filter-api-2025';
     }
      
      let ajaxURL = `${datacollurlNew}?view=${apiTemplate}`;
      if (currentURL.includes('?')) {
        ajaxURL = `${currentURL}&view=${apiTemplate}`;
      }
    
    $.ajax({
       url: ajaxURL,
       type: 'GET',
       dataType: 'html',
       success: function(responseHTML){
         $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
       }
     })
    
  }
}
  // nav bar open/close on click - Mobile menu
  // $('body').on('click','.mobile-nav__link',function(){
  //   let navItemclicked = $(this).attr('aria-controls');
  //   $('.mobile-nav__link').each(function(){
  //     let navItem = $(this).attr('aria-controls');
  //     if (navItemclicked != navItem) {
  //       $(this).attr('aria-expanded', false);
  //       $(this).siblings('collapsible-content').css("overflow", "hidden");
  //       $(this).siblings('collapsible-content').removeAttr("open");
  //     }
  //   })
  // })



$('body').on('click', '.cart_title_remove_icon', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__remove-button');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});
  
$('body').on('click', '.line-itemprop_edit .edit_set', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__content-wrapper .line-item__image-wrapper');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});


  $('body').on('click','men-item .back_menu', function(){
    const mobileNavItem = $(this).closest(".mobile-nav__item");
      if (mobileNavItem) {
        const toggleButton = mobileNavItem.find('button[aria-expanded="true"]');
        if (toggleButton) {
            toggleButton.click();
        }
    }
  })
  
  // new home tab section
  $('.new_tab_single').on('click',function(){
      $('.new_tab_single').removeClass('active')
      $(this).addClass('active')

      $('.new_tabs_content').hide()
      $(`.new_tabs_content[data-id=${$(this).attr('id')}]`).show();
    })

// Define the global removeSet function attached to the window object
window.removeSet = function(event) {
    event.preventDefault();
    const clickedButton = event.currentTarget;

    let setIDParent = clickedButton.getAttribute('data-set-id');

    let lineItemLoader = $(`line-item[data-parent-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoader.removeAttr('hidden');
    lineItemLoader.find('.line-item__loader-spinner').removeAttr('hidden');
    let lineItemLoaderSet = $(`line-item[data-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoaderSet.removeAttr('hidden');
    lineItemLoaderSet.find('.line-item__loader-spinner').removeAttr('hidden');

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let itemsToRemove = [];

            cart.items.forEach(item => {
                for (let propertyName in item.properties) {
                    if (item.properties.hasOwnProperty(propertyName) && propertyName === '_set_id' && item.properties[propertyName] === setIDParent) {
                        itemsToRemove.push({
                            id: item.key,
                            quantity: 0
                        });
                    }
                }
            });

            if (itemsToRemove.length > 0) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        updates: itemsToRemove.reduce((acc, item) => {
                            acc[item.id] = item.quantity;
                            return acc;
                        }, {})
                    })
                })
                .then(response => response.json())
                .then(() => {
                    document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
                })
                .catch(error => console.error('Error:', error));
            } else {
              document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
            }
        })
        .catch(error => console.error('Error:', error));
}



    $('body').on('mouseenter', 'color-choose-drawer#color-choose-drawer .product__media-list', function () {
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', 'color-choose-drawer#color-choose-drawer .product__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});


$('body').on('mouseenter', 'color-choose-drawer#color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
            if ($secondDot.length) {
                $secondDot.trigger('click');
            }
            const $secondDotList = $pageDots.find('li:nth-child(2)');
            if ($secondDotList.length) {
                $secondDotList.trigger('click');
            }
        }
    }
});

$('body').on('mouseleave', 'color-choose-drawer#color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
            const $firstDotList = $pageDots.find('li:nth-child(1)');
            if ($firstDotList.length) {
                $firstDotList.trigger('click');
            }
        }
    }
});


  $('body').on('mouseenter', '.flickity__media-list', function () {
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.flickity__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});
  
  // collection 2025
    $('body').on('mouseenter', '.product__media-list', function () {
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.product__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});


$('body').on('click', '.filter_farbe_image .farbe_image', function(){
  const dataName = $(this).attr('data-name');
  const dataVal = $(this).attr('data-value');
  if ($(this).hasClass('active_color')) {
    $(this).removeClass('active_color');
  } else {
    $(this).addClass('active_color');
  }
  $('form#facet-filters-form').find(`input[name="${dataName}"]`).each(function(){
    if ($(this).val() == dataVal) {
      $(this).click();
    }
  })
})

$('body').on('click', '.other_filters .facetfilter_btn', function(){
  const dataControl = $(this).attr('data-aria-controls');
  $('button.product-facet__meta_filter').click();
  $(`.product-facet__filter-item .collapsible-toggle[aria-expanded="true"]`).each(function(){
    $(this).attr('aria-expanded', 'false');
  });
  $(`.product-facet__filter-item .collapsible-toggle[aria-controls="${dataControl}"]`).click();
}) 

  
}); // ready function end


// Size guide
$(document).ready(function () {

    $('body').on('click', '.pick_design_sizeguide', function(){
        $(".popup_sizeguide_section").addClass("active");
    });

    $('body').on('click', '.custom_accordion_btn[data-block-title="shapes-lengths"]', function(){
        setTimeout(() => {
          if ($(this).attr('aria-expanded') == 'true') {
            $(".popup_sizeguide_section").addClass("active");
          }
        }, 200);
    });

  
    $(".close-icon-popup, .choose_style_btn, .drawer__overlay").click(function () {
        $('.custom_accordion_btn[data-block-title="shapes-lengths"]').attr('aria-expanded', 'false');
        $(".popup_sizeguide_section").removeClass("active");
    });

  // Size guide tab
    $(".shape_category").click(function(){
        var name = $(this).attr("data-name");
        $(".shape_category, .point_shapelenght_inner").removeClass("active");
        var matchingElement = $(".point_shapelenght_inner[data-content='" + name + "']");
        if(matchingElement.length) {
            $(this).addClass("active");
            matchingElement.addClass("active");
        }
    });
});

